/**
 * Carrega posições do armazém via API no datalist do campo (lista completa do sistema).
 * Ao digitar, refina com filtro no endereço (case-sensitive). No blur, resolve endereço → id.
 */
import { loadOptions } from '../../versa/formset.js';
import {
	fetchWarehouseLocations,
	resolveCompanyId,
	resolveWarehouseId,
	resolveLocationIdForMove,
	fmtLocAddr,
} from '../utils/location-search.js';

function findOption(node, value)
{
	const opts = Array.from(node?.list?.options ?? []);
	const v = String(value ?? '').trim();
	return opts.find((o) => String(o.value).trim() === v || o.value == value);
}

export default function (opts = {})
{
	const companyKey = opts.companyKey || 'target_warehouse_company_id';
	const warehouseKey = opts.warehouseKey || 'target_warehouse_id';
	const isExpedition = opts.isExpedition === true;
	const debounceMs = opts.debounceMs ?? 280;
	let debounceTimer = null;

	return {

		captureEvents(_this = this)
		{
			this.safeProtoCall(_this);
			const node = document.querySelector(this.selector);
			if (node)
			{
				node.addEventListener('input', (ev) => this._onInput(ev));
				node.addEventListener('blur', (ev) => { void this._onBlur(ev); });
			}
		},

		_getScope()
		{
			const coRaw = this.locate(this.makeId(companyKey))?.getValue?.()
				?? document.querySelector(this.makeId(companyKey))?.value;
			const whRaw = this.locate(this.makeId(warehouseKey))?.getValue?.()
				?? document.querySelector(this.makeId(warehouseKey))?.value;
			return { coRaw, whRaw };
		},

		async _resolveScopeIds()
		{
			const { coRaw, whRaw } = this._getScope();
			const companyId = await resolveCompanyId(coRaw);
			const warehouseId = await resolveWarehouseId(companyId, whRaw);
			return { companyId, warehouseId };
		},

		async _reload(searchText = '')
		{
			const node = document.querySelector(this.selector);
			const preserve = String(searchText ?? (node?.value ?? '')).trim();
			const { companyId, warehouseId } = await this._resolveScopeIds();
			if (!companyId || !Number.isInteger(warehouseId) || warehouseId < 1)
			{
				loadOptions(this.selector, [], 'id', ['address'], '-');
				if (node && preserve)
					node.value = preserve;
				return;
			}
			const term = preserve;
			const rows = await fetchWarehouseLocations(companyId, warehouseId, {
				search: term,
				limit: term ? 80 : 0,
				silent: true,
				exactAddress: term.length > 0 && term.includes('-'),
				isExpedition,
			});
			loadOptions(this.selector, rows, 'id', ['address'], '-');
			if (node && preserve)
				node.value = preserve;
		},

		async _onBlur()
		{
			const node = document.querySelector(this.selector);
			if (!node)
				return;
			const typed = String(node.value ?? '').trim();
			if (!typed)
				return;
			const current = this.getValue();
			if (findOption(node, current))
				return;
			await this._reload(typed);
			if (findOption(node, this.getValue()))
				return;
			const { companyId, warehouseId } = await this._resolveScopeIds();
			if (!companyId || !Number.isInteger(warehouseId) || warehouseId < 1)
				return;
			const locId = await resolveLocationIdForMove(companyId, warehouseId, typed);
			if (!Number.isInteger(locId) || locId < 1)
				return;
			this.setValue(locId);
			this.checkErrorState?.();
			this.refresh?.();
			const opt = findOption(node, locId);
			if (opt)
				node.value = opt.innerText || fmtLocAddr(opt.label);
		},

		_onInput(ev)
		{
			if (ev.inputType === 'insertReplacementText')
				return;
			clearTimeout(debounceTimer);
			const typed = String(ev.target?.value ?? '').trim();
			debounceTimer = setTimeout(async () =>
			{
				try { await this._reload(typed); }
				catch (err) { console.error('location search reload', err); }
			}, debounceMs);
		},

		async actions()
		{
			clearTimeout(debounceTimer);
			const node = document.querySelector(this.selector);
			const typed = node ? String(node.value ?? '').trim() : '';
			await this._reload(typed);
		},

	};
}
